/**
 * Pelvia design tokens — single source of truth for web and mobile.
 *
 * Plain JS object so the same values drive Tailwind (web), NativeWind (mobile),
 * and any direct StyleSheet uses.
 */

export const colors = {
  bg: '#F6F4F9',
  surface: '#FFFFFF',
  surfaceHover: '#FDFCFF',
  surface2: '#F0ECF5',
  surface3: '#E8E3F0',
  warmWhite: '#FDFCFF',

  accent: '#7B5E80',
  accentLight: '#A8A0D0',
  accent2: '#D4A0C8',
  brownLight: '#9B9ED2',
  brownDark: '#5A3D60',

  sidebarBg: '#3D3558',
  sidebarText: '#C5C0D8',
  sidebarActive: '#FFFFFF',

  border: '#E2DCE8',
  borderLight: '#EEEAF2',
  border2: 'rgba(61,53,88,0.14)',

  textPrimary: '#2D2843',
  textSecondary: '#6E6788',
  textMuted: '#A9A3BA',
  textTertiary: '#A09AB2',

  success: '#4CAF50',
  warning: '#F59E0B',
  danger: '#EF4444',

  pain: [
    '#4CAF50', '#66BB6A', '#8BC34A', '#CDDC39', '#FFEB3B',
    '#FFC107', '#FF9800', '#FF5722', '#F44336', '#D32F2F', '#B71C1C',
  ],

  medPurple: '#6355A0',
  medRose: '#C04470',
  medGreen: '#2E9068',
  medAmber: '#B87020',
} as const

export const fonts = {
  serif: "'Fraunces', Georgia, serif",
  sans: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
} as const

export const radii = {
  sm: 6,
  md: 10,
  lg: 14,
  xl: 20,
} as const
